import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

export class SnAlarmMarker extends SnModel {
  @Expose()
  public format: string;

  @Expose()
  public icon: string;

  constructor(data?: any) {
    super();
    this.fromJSON(data);
  }
}
